module.exports = __webpack_public_path__ + "static/media/image5.6efcd9b8.png";